import React from 'react';

function SyllabusEditor({ pageContent, setPageContent, uploading, uploadingField, addTableRow, deleteTableRow, updateTableRow, handleFileUpload }) {
  
  const handleSyllabusFileUpload = async (itemId, file) => {
    if (!file) return;
    
    try {
      const { uploadFile } = await import('../../firebase/firebase-config');
      const fileData = await uploadFile(file, `syllabus/${itemId}_${Date.now()}_${file.name}`);
      
      // Update the specific syllabus item with file info
      const newItems = (pageContent.syllabusItems || []).map(item => 
        item.id === itemId ? { ...item, file: fileData, fileName: file.name } : item
      );
      setPageContent({ ...pageContent, syllabusItems: newItems });
      alert('✅ Syllabus file uploaded successfully!');
    } catch (error) {
      alert('❌ Error uploading file: ' + error.message);
    }
  };

  const handleDeleteSyllabusFile = async (itemId, fileUrl) => {
    if (!fileUrl) return;
    
    if (window.confirm('Delete this syllabus file permanently?')) {
      try {
        const { deleteFileFromStorage } = await import('../../firebase/firebase-config');
        await deleteFileFromStorage(fileUrl);
        
        // Remove file from the syllabus item
        const newItems = (pageContent.syllabusItems || []).map(item => 
          item.id === itemId ? { ...item, file: null, fileName: null } : item
        );
        setPageContent({ ...pageContent, syllabusItems: newItems });
        alert('✅ File deleted successfully!');
      } catch (error) {
        alert('❌ Error deleting file: ' + error.message);
      }
    }
  };

  return (
    <div className="page-editor">
      <div className="editor-card">
        <h3>📋 Syllabus</h3>
        
        <div className="form-group">
          <label>Academic Session</label>
          <input 
            type="text" 
            value={pageContent.session || '2025-26'} 
            onChange={(e) => setPageContent({...pageContent, session: e.target.value})} 
            className="form-input" 
            placeholder="e.g., 2025-26"
          />
          <small style={{display: 'block', marginTop: 5, color: '#64748b'}}>
            The academic year for which this syllabus applies
          </small>
        </div>

        <div className="form-group">
          <label>Page Title</label>
          <input 
            value={pageContent.title || 'Syllabus'} 
            onChange={(e) => setPageContent({...pageContent, title: e.target.value})} 
            className="form-input" 
          />
        </div>

        <h4 style={{marginTop: 20, marginBottom: 15}}>Syllabus Items by Class</h4>
        
        {(pageContent.syllabusItems || []).map((s) => (
          <div key={s.id} style={{border:'1px solid #e2e8f0', padding:15, marginBottom:15, borderRadius:8, position:'relative'}}>
            <div style={{display:'flex', gap:10, marginBottom:10, flexWrap:'wrap'}}>
              <input 
                placeholder="Class (e.g., Class 1, Nursery)" 
                value={s.class || ''} 
                onChange={(e) => updateTableRow('syllabusItems', s.id, 'class', e.target.value)} 
                style={{flex:1}} 
                className="form-input" 
              />
              <input 
                placeholder="Term (e.g., Term 1, Annual)" 
                value={s.term || ''} 
                onChange={(e) => updateTableRow('syllabusItems', s.id, 'term', e.target.value)} 
                style={{flex:1}} 
                className="form-input" 
              />
            </div>
            
            {s.file && s.file.url && (
              <div style={{marginBottom: 10, padding: 8, background: '#f1f5f9', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <a href={s.file.url} target="_blank" rel="noopener noreferrer" style={{color: '#1a3a6b', textDecoration: 'none'}}>
                  📄 {s.fileName || 'Syllabus File'}
                </a>
                <button 
                  className="remove-btn" 
                  onClick={() => handleDeleteSyllabusFile(s.id, s.file.url)}
                  style={{padding: '4px 10px'}}
                >
                  🗑️ Delete
                </button>
              </div>
            )}
            
            <div style={{display: 'flex', gap: 10, marginBottom: 10}}>
              <label className="upload-label" style={{margin: 0}}>
                {uploading && uploadingField === `file_${s.id}` ? '⏳ Uploading...' : '📎 Upload PDF Syllabus'}
                <input 
                  type="file" 
                  accept=".pdf" 
                  style={{display:'none'}} 
                  onChange={(e) => { 
                    if (e.target.files[0]) handleSyllabusFileUpload(s.id, e.target.files[0]); 
                  }} 
                />
              </label>
              <button 
                className="remove-btn" 
                onClick={() => deleteTableRow('syllabusItems', s.id)}
              >
                🗑️ Remove Item
              </button>
            </div>
          </div>
        ))}
        
        <button 
          className="add-btn" 
          onClick={() => addTableRow('syllabusItems', { class: '', term: '', file: null, fileName: null })}
        >
          + Add Syllabus Item
        </button>

        <div className="form-group" style={{marginTop: 20}}>
          <label>Preview</label>
          <div style={{background: '#f8fafc', padding: 16, borderRadius: 8, fontSize: 14}}>
            <p><strong>Session:</strong> {pageContent.session || 'Not set'}</p>
            <p><strong>Syllabus Items:</strong> {(pageContent.syllabusItems || []).length} item(s)</p>
            <p><strong>Files Uploaded:</strong> {(pageContent.syllabusItems || []).filter(i => i.file).length}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SyllabusEditor;